import React from 'react';
import styles from './RelatedRequest.module.scss';
import cn from 'classnames';
import RelatedRequestHeader from './components/RelatedRequestHeader/RelatedRequestHeader';
import RelatedRequestBody from './components/RelatedRequestBody/RelatedRequestBody';
import RelatedRequestPreview from './components/RelatedRequestPreview/RelatedRequestPreview';
import { Spin, Tooltip } from 'antd';
import useRequestAttachments from '../../../../../queries/useRequestAttachments';
import moment from 'moment';
import { declOfNum, dspxDiffDays } from '../../../../../helpers/dspx-utils';
import IndicatorBadge from '../../common/IndicatorBadge/IndicatorBadge';
import { requestFlatPeriod } from '../../../constants/requestFlat';
import { requestInPeriodColorMap } from '../../../constants/stagesColorMaps';

const RelatedRequest = ({
  request,
  onItemClick,
  dayExcess,
  className,
  isExpiredIndicators = true,
  isDedlineIndicators = true,
  isExcessIndicators = true,
}) => {
  const { data: attachments, isFetching } = useRequestAttachments(request.id, {
    staleTime: Infinity,
  });

  const showAttachments = attachments && attachments.length > 0;

  const dayExpired = request.doneDateTime
    ? dspxDiffDays(request.doneDateTime, request.executeDateTime)
    : dspxDiffDays(0, request.executeDateTime);

  const hasExpired =
    !isNaN(dayExpired) &&
    request.statusId !== 4 &&
    Number(dayExpired) > 0 &&
    !request.doneDateTime &&
    isExpiredIndicators;

  const titleExpired =
    'Просрочено на ' +
    (dayExpired > 0
      ? dayExpired +
        declOfNum(dayExpired, [' день', ' дня', ' дней']) +
        (request.executeTime ? '' : ' / Нет даты назначения')
      : '?');

  const hasDedline =
    dspxDiffDays(request.executeDateTime, moment().toString()) >= 0 &&
    dspxDiffDays(request.executeDateTime, moment().toString()) <= 7 &&
    !request.doneDateTime &&
    (request.statusId === 1 || request.statusId === 2) &&
    isDedlineIndicators;

  const dayDedline = hasDedline
    ? dspxDiffDays(request.executeDateTime, moment().toString())
    : null;

  const titleDedline =
    dayDedline === 0
      ? 'Последний день до выполнения'
      : `До выполнения ${dayDedline} ${declOfNum(dayDedline, [
          ' день',
          ' дня',
          ' дней',
        ])}`;

  const hasExcess =
    !!dayExcess &&
    (request?.statusId === 1 || request?.statusId === 2) &&
    moment(request.executeDateTime).isAfter(moment(dayExcess), 'day') &&
    isExcessIndicators;

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.indicatorsContainer}>
        {hasDedline && (
          <Tooltip title={titleDedline}>
            <IndicatorBadge
              style={{ width: '15px', height: '15px' }}
              withBorder
              bgColor={requestInPeriodColorMap.get(requestFlatPeriod.rightTime)}
            />
          </Tooltip>
        )}
        {hasExpired && (
          <Tooltip title={titleExpired}>
            <IndicatorBadge
              style={{ width: '15px', height: '15px' }}
              withBorder
              bgColor={requestInPeriodColorMap.get(requestFlatPeriod.expired)}
            />
          </Tooltip>
        )}
        {hasExcess && (
          <Tooltip title="Превышение проверочной даты">
            <IndicatorBadge
              style={{ width: '15px', height: '15px' }}
              withBorder
              bgColor={requestInPeriodColorMap.get(requestFlatPeriod.excess)}
            />
          </Tooltip>
        )}
      </div>
      <RelatedRequestHeader
        request={request}
        onItemClick={onItemClick}
      />
      <RelatedRequestBody request={request} />
      {isFetching ? (
        <Spin />
      ) : showAttachments ? (
        <RelatedRequestPreview
          attachments={attachments}
          requestId={request.id}
        />
      ) : null}
    </div>
  );
};

export default RelatedRequest;
